// extracted by mini-css-extract-plugin
export default {"mainFormContanier":"Contact_mainFormContanier__QU649","formDetailsContainer":"Contact_formDetailsContainer__aqigr"};